import React, { memo, useMemo } from 'react';
import classnames from 'classnames';
import { Text, Spacer, Divider, Button, Menus, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

import './styles.scss';

const SettingsLayout = memo(
    ({ title, description, className, withoutDivider, learnMoreItems, children }) => {
        const theme = useTheme();

        const learnMoreMenu = useMemo(() => {
            if (!learnMoreItems?.length) return null;

            return (
                <Menus
                    title={
                        <Button type="terciary" size="small" icon="infoOutlined">
                            {getLiteral('label_learn_more')}
                        </Button>
                    }
                    items={learnMoreItems}
                />
            );
        }, [learnMoreItems]);

        return (
            <div className={classnames('fm-settings-layout', className)}>
                <div className="fm-settings-layout__header">
                    <div className="fm-settings-layout__title-container">
                        <Text type="h5" className="fm-settings-layout__title">
                            {title}
                        </Text>
                        {learnMoreMenu}
                    </div>
                    <Spacer y={2} />
                    {description && (
                        <Text
                            className="fm-settings-layout__description"
                            color={theme.colors.utility.textSecondary}
                        >
                            {description}
                        </Text>
                    )}
                </div>
                <Spacer y={4} />
                {!withoutDivider && <Divider />}
                <Spacer y={4} />
                <div className="fm-settings-layout__content">{children}</div>
            </div>
        );
    },
);

export default SettingsLayout;
